import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

type Arguments = {
    id: string;
};

export const schemaUserResolver_IsDeactivated = z.boolean();

export type SchemaUserResolver_IsDeactivated = z.infer<typeof schemaUserResolver_IsDeactivated>;

export type UserResolver_IsDeactivated = Resolver<Arguments, SchemaUserResolver_IsDeactivated>;
